import { Tag } from "gen/tag/models_pb"
import { UUID } from "shared-ts/classes/uuid"

import { data } from "./data"
import { TypedAccessor } from "./types"
import {
  extractTagColor,
  Tag as TagComponent,
} from "../../../../components/base/informational/Tag"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type TagsAccessorFn<T> = TypedAccessor<T, Tag[] | undefined>
type TagsColumn<T> = Omit<DataColumn<T>, "type" | "renderCell" | "width">
export type TagsColumnHelper<T> = (
  accessorFn: TagsAccessorFn<T>,
  col: TagsColumn<T>
) => DataColumn<T>

export function tags<T>(
  accessorFn: TagsAccessorFn<T>,
  col: TagsColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const tags = accessorFn(rowData)
      if (!tags) return null
      return (
        <div className="flex flex-row gap-x-1">
          {tags.map((tag) => (
            <TagComponent
              key={UUID.idString(tag.id)}
              name={tag.name}
              color={extractTagColor(tag.color)}
            />
          ))}
        </div>
      )
    },
    width: TableCellWidth.ExtraExtraExtraLarge,
    ...col,
  })
}
